import { openAtoClassificationModal } from 'containers/ResolutionCenter/AccountTakeOverClassificationModal/actions'

import {
  CHANGE_ASSIGNEES_ASYNC,
  CHANGE_INCIDENT_STATE_REQUEST_ASYNC,
  RESET_REMEDIATION_CONFIRMATION,
  TOGGLE_REMEDIATION_ACTION,
} from './constants'

export const toggleRemediationAction = (actionType) => ({
  type: TOGGLE_REMEDIATION_ACTION,
  payload: { actionType },
})

const changeIncidentState = (incidentId, newState) => ({
  type: CHANGE_INCIDENT_STATE_REQUEST_ASYNC.INITIATE,
  payload: { incidentId, newState },
})
export const changeIncidentStateSuccess = (newState) => ({
  type: CHANGE_INCIDENT_STATE_REQUEST_ASYNC.SUCCESS,
  payload: { newState },
})
export const changeIncidentStateError = (error) => ({
  type: CHANGE_INCIDENT_STATE_REQUEST_ASYNC.ERROR,
  error,
})
const changeIncidentStateCancel = () => ({
  type: CHANGE_INCIDENT_STATE_REQUEST_ASYNC.CANCEL,
})
const resetRemediationConfirmation = () => ({
  type: RESET_REMEDIATION_CONFIRMATION,
})

const changeAtoAssignees = (incidentId, assigneeId) => ({
  type: CHANGE_ASSIGNEES_ASYNC.INITIATE,
  payload: { incidentId, assigneeId },
})
export const changeAtoAssigneesSuccess = (data) => ({
  type: CHANGE_ASSIGNEES_ASYNC.SUCCESS,
  payload: { data },
})
export const changeAtoAssigneesError = (error) => ({
  type: CHANGE_ASSIGNEES_ASYNC.ERROR,
  error,
})
export const changeAtoAssigneesCancel = (error) => ({
  type: CHANGE_ASSIGNEES_ASYNC.CANCEL,
  error,
})

export default {
  // to props
  changeIncidentState,
  changeIncidentStateCancel,
  toggleRemediationAction,
  resetRemediationConfirmation,
  openAtoClassificationModal,
  changeAtoAssignees,
  changeAtoAssigneesCancel,
}
